import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from '@/locales/en'
import it from '@/locales/it'
import de from '@/locales/de'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: localStorage.getItem('language') || 'en', // set locale from localStorage or default to 'en'
  fallbackLocale: 'en', // set fallback locale
  messages: { en, it, de }
})

export default i18n 